import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
//services
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';

@Component({
  selector: 'app-review-iden-modal',
  templateUrl: './review-iden-modal.component.html',
  styleUrls: ['./review-iden-modal.component.css']
})
export class ReviewIdenModalComponent implements OnInit {

  @Input() id: any;
  @Input() page: string;
  formData: { [key: string]: any } = {};
  companyName: any;
  portalSettings: any;
  raceList: any[] = [];
  validateCheck: boolean = true;   
  hideFederalMsgSelfIden: boolean = false;
  selectedRace: any;
  datePickerOptions: { dateInputFormat: string; };

  constructor(portalSettingsService: PortalSettingsService, private hiringService: HiringService, private activeModal: NgbActiveModal) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.datePickerOptions = { dateInputFormat: "YYYY-MM-DD" };
    this.companyName = this.portalSettings.CareerJobCompanyName.ConfigValue;
    if(this.page == "applicant"){
      this.getApplicantRaceCodes();
      this.formData.selectedSex = this.id.Gender;
      this.formData.selectedVeteran = this.id.Veteran;
      this.formData.selectedDisability = this.id.Disability;
      this.formData.GenderIdentity = this.id.GenderIdentity;
      this.formData.GenderIdentity_OtherDesc = this.id.GenderIdentity_OtherDesc;
      this.formData.Veteran_Disabled = this.id.Veteran_Disabled?.toString();
      this.formData.Veteran_AFServiceMedal = this.id.Veteran_AFServiceMedal?.toString();
      this.formData.Veteran_ActiveDutyWartime = this.id.Veteran_ActiveDutyWartime?.toString();
      if (this.id.Veteran_DischargeDate != null)
        this.formData.Veteran_DischargeDate = new Date(parseInt(moment.utc(this.id.Veteran_DischargeDate).format("YYYY")), parseInt(moment.utc(this.id.Veteran_DischargeDate).format("MM")) - 1, parseInt(moment.utc(this.id.Veteran_DischargeDate).format("DD")), 0, 0, 0, 0);
    }else{
      this.getRaceCodes();
    }
  }

  getRaceCodes() {
    this.hiringService.getRaceCodes().then((response: any) => {
      this.raceList = response;
      this.raceList.push({ Race: "X", Description: "I do not wish to answer" });
      this.hiringService.getDashboard(this.id, null).then((response: any) => {
        if(response != null){
          this.formData.selectedSex = response[0].Gender;
          if (response[0].RaceEthnic != null) {
            this.raceList.forEach((val: any) => {
              val.Race = val.Race.toString().trim();
              if (val.Race == response[0].RaceEthnic.trim()) {
                this.formData.selectedRace = val.Race;
                this.formData.selectedRace = this.formData.selectedRace.toString().trim();
              }
            });
          }
        }
        this.formData.selectedVeteran = response[0].Veteran;
        this.formData.selectedDisability = response[0].Disability;
        this.formData.GenderIdentity = response[0].GenderIdentity;
        this.formData.GenderIdentity_OtherDesc = response[0].GenderIdentity_OtherDesc;
        this.formData.Veteran_Disabled = response[0]?.Veteran_Disabled?.toString();
        this.formData.Veteran_AFServiceMedal = response[0]?.Veteran_AFServiceMedal?.toString();
        this.formData.Veteran_ActiveDutyWartime = response[0]?.Veteran_ActiveDutyWartime?.toString();
        if (response[0].Veteran_DischargeDate != null)
          this.formData.Veteran_DischargeDate = new Date(parseInt(moment.utc(response[0].Veteran_DischargeDate).format("YYYY")), parseInt(moment.utc(response[0].Veteran_DischargeDate).format("MM")) - 1, parseInt(moment.utc(response[0].Veteran_DischargeDate).format("DD")), 0, 0, 0, 0);
      });
    });
  }

  getApplicantRaceCodes(){
    this.hiringService.getRaceCodes().then((response: any)=> {
      if(response != null){
        this.raceList = response;
      this.raceList.push({ Race: "X", Description: "I do not wish to answer" });
      if (this.id.RaceEthnic != null) {
          this.raceList.forEach((val: any)=> {
            val.Race = val.Race.toString().trim();
            if (val.Race == this.id.RaceEthnic.trim()) {
              this.formData.selectedRace = val.Race;
              this.formData.selectedRace = this.formData.selectedRace.toString().trim();
            }})
      }
      }
  });
  }


  closeClick() {
    this.activeModal.dismiss();
  }

}
